// 警報彈窗（LIVE-09）：哪些事件自動帶出畫面、帶到浮窗還是影像牆的指定格位。存在這台瀏覽器，每個控制項改了就生效。
// 跟浮動通知三檔放在同一張卡（VMS UX 評審第三輪 R3-P0-2 ⑤、SPEC NOTIF-02 ①）：每個勾選各占一行。
import { useTranslation } from 'react-i18next';
import { usePopupPrefs, type PopupPrefs } from '../../lib/alarmPopup';

export function PopupPrefsCard() {
  const { t } = useTranslation();
  const [prefs, save] = usePopupPrefs();
  const set = (patch: Partial<PopupPrefs>) => save({ ...prefs, ...patch });
  const check = (k: 'sensor' | 'alarm' | 'detection') => (
    <label className="check" key={k}>
      <input type="checkbox" checked={prefs[k]} onChange={(e) => set({ [k]: e.target.checked })} />
      <span>
        {t(`popup.${k}`)}
        <span className="muted small"> — {t(`popup.${k}_help`)}</span>
      </span>
    </label>
  );
  return (
    <fieldset className="popup-prefs" aria-label={t('popup.title')} role="region">
      <legend>{t('popup.title')}</legend>
      <p className="muted small">{t('popup.help')}</p>
      {check('sensor')}
      {check('alarm')}
      {check('detection')}
      <div className="toolbar">
        <label className="field">
          <span>{t('popup.target')}</span>
          <select
            className="input"
            value={prefs.target}
            onChange={(e) => set({ target: e.target.value === 'cell' ? 'cell' : 'float' })}
            aria-label={t('popup.target')}
          >
            <option value="float">{t('popup.target_float')}</option>
            <option value="cell">{t('popup.target_cell')}</option>
          </select>
        </label>
        {prefs.target === 'cell' && (
          <label className="field">
            <span>{t('popup.cell')}</span>
            <input
              className="input"
              type="number"
              min={1}
              max={64}
              value={prefs.cell + 1}
              aria-label={t('popup.cell')}
              onChange={(e) => {
                const n = Math.floor(Number(e.target.value));
                if (n >= 1 && n <= 64) set({ cell: n - 1 });
              }}
            />
          </label>
        )}
      </div>
      {prefs.target === 'cell' && <p className="muted small">{t('popup.cell_help')}</p>}
    </fieldset>
  );
}
